export default {
	path: 'dataAnalysis',
	component: () => import( /* webpackChunkName: "dataAnalysis" */ '@/pages/dataAnalysis/index'),
	meta: {
		title: '数据统计'
	},
	children: [{
		path: 'detail/:id',
		component: () => import( /* webpackChunkName: "dataAnalysis" */ '@/pages/dataAnalysis/dataDetail'),
		meta: {
			title: '数据总览'
		},
	}]
}
